// src/tabs/context.ts
import { createContext, useContext } from "react";
var TabsContext = createContext(null);
function useTabsContext() {
  const context = useContext(TabsContext);
  if (!context) {
    throw new Error(
      "Tabs context required. Did you use `<Tabs.List />`, `<Tabs.Tab />`, or `<Tabs.Content />` outside of <Tabs/>?"
    );
  }
  return context;
}

export {
  TabsContext,
  useTabsContext
};
//# sourceMappingURL=chunk-KQITCS3U.mjs.map